import { ApolloLink } from 'apollo-link'

export const createClientHeaders = () =>
  new ApolloLink((operation, forward) => {
    // Add client version headers to monitor API calls
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        'x-client-name': 'cloud-frontend',
        'x-client-version':
          process.env.REACT_APP_RELEASE_VERSION ||
          process.env.REACT_APP_COMMIT_HASH,
      },
    }))

    return forward(operation)
  })
